import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function EuroIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16 7.8082C15.2924 6.9994 14.396 6.4523 13.423 6.23553C12.45 6.01875 11.4438 6.14193 10.5306 6.58963C9.61734 7.03733 8.83773 7.78961 8.2895 8.75215C7.74127 9.71469 7.44882 10.8446 7.44882 12.0003C7.44882 13.156 7.74127 14.2859 8.2895 15.2485C8.83773 16.211 9.61734 16.9633 10.5306 17.411C11.4438 17.8587 12.45 17.9819 13.423 17.7651C14.396 17.5483 15.2924 17.0012 16 16.1924M12.4786 10.3235H5.77124M5.77124 13.6772H12.4786"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2.04575"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0.999999C5.92487 0.999998 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 0.999999 12 0.999999Z"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
        />
      </svg>
    </SvgIcon>
  );
}
